import {ContentBox} from '@hconnect/common/components'
import CloseIcon from '@mui/icons-material/Close'
import {Typography, IconButton, Alert} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  onClose: () => void
}

export const MissingTaskDataError = ({onClose}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <ContentBox
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      title={
        <Typography component="span" variant="h2">
          {t('task.message.taskNotFound')}
        </Typography>
      }
      afterTitle={
        <IconButton onClick={() => onClose()} data-test-id="task-details-close">
          <CloseIcon color="primary" />
        </IconButton>
      }
      headerSx={{paddingBottom: 0}}
    >
      <Alert severity="info" sx={{mt: 2}}>
        {t('task.message.taskDetailsNotAvailable')}
      </Alert>
    </ContentBox>
  )
}
